// When a voucher code is added to the cart but it does not actually apply to any lineItems
// then it will show up in the `vouchers` array but _not_ in the `appliedDiscounts`.
// This function returns all of the vouchers that are currently not applicable to any lineItems
const getUnappliedVoucherCodes = (vouchers, appliedDiscounts)=>{
    return vouchers === null || vouchers === void 0 ? void 0 : vouchers.filter((voucher)=>!appliedDiscounts.some(({ code  })=>code === voucher.code
        )
    );
};

export { getUnappliedVoucherCodes };
//# sourceMappingURL=get-unapplied-voucher-codes.js.map
